<template>
  <div class="aiTool">
    <div class="Tool_item" v-for="(item,index) in toolList">
      <div class="item_title" :class="index!=0?'margin_t':''">{{ item.title }}</div>
      <div class="list">
        <div v-for="(list,index) in item.list" @click="jumpChild(list,index)" class="item">
          <div class="item_box">
            <img alt="" class="item_img" :src="list.img">
            <h3 class="item_h">{{list.name }}</h3>
            <p class="item_p">{{list.guide}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toolList: [
        {
          title: '工具箱', list: [
            {
              id: 1,
              relation: 0,
              name: '花花世界',
              guide: '上传照片，先生成属于你的开花图片。主体物明确、轮廊清晰的照片效果最佳。',
              img: require('./img/aiTool/01.gif'),
              tag2: 'bloombloom',
            },
            {
              id: 2,
              relation: 0,
              name: '魔力转圈圈介绍',
              guide: '魔力转圈圈可以应用于单图特效，为静态图片添加动态旋转效果。',
              img: require('./img/aiTool/02.gif'),
              tag2: 'dizzydizzy',
            },
            {
              id: 3,
              relation: 0,
              name: '快来惹毛我',
              guide: '只需上传一张以人物或物品为主体的图片，即可生成具有“反差萌”效果的创意视频。',
              img: require('./img/aiTool/03.gif'),
              tag2: 'fuzzyfuzzy',
            },
            {
              id: 4,
              relation: 0,
              name: '捏捏乐',
              guide: '上传一张以人物或物品为主体的图片，即可生成具有柔软、Q弹效果的动态视频。',
              img: require('./img/aiTool/04.gif'),
              tag2: 'squish',
            },
            {
              id: 5,
              relation: 0,
              name: '万物膨胀',
              guide: '通过夸张的膨胀效果，为原本普通的图像增添了诙谐和反差萌的视觉效果',
              img: require('./img/aiTool/05.gif'),
              tag2: 'expansion',
            },
            {
              id: 6,
              relation: 0,
              name: '一键变手办',
              guide: '将用户上传的照片转换成具有手办风格的图像或3D模型。生成的手办形象通常具有夸张的特征、鲜明的色彩和精致的细节，呈现出独特的视觉效果',
              img: require('./img/aiTool/06.gif'),
              tag2: 'Labubu Style',
            },
            {
              id: 7,
              relation: 0,
              name: '一键拍立得',
              guide: '用户只需上传一张照片，即可快速生成具有3D立体感和拍立得风格的动态视频效果',
              img: require('./img/aiTool/07.gif'),
              tag2: 'Magic Polaroid',
            },
            {
              id: 8,
              relation: 0,
              name: '拥抱',
              guide: '适用于情侣、朋友等双人互动场景，能够为视频创作增添温馨、亲密的氛围',
              img: require('./img/aiTool/08.gif'),
              tag2: 'hug',
            },
            {
              id: 9,
              relation: 0,
              name: '亲吻',
              guide: '能够生成自然且流畅的亲吻动作，让静态图片瞬间“动起来”，效果逼真',
              img: require('./img/aiTool/09.gif'),
              tag2: 'kiss',
            },
            {
              id: 10,
              relation: 0,
              name: '比心',
              guide: '适合用于表达爱意、祝福等情感的视频创作，能够营造出浪漫或友好的氛围',
              img: require('./img/aiTool/10.gif'),
              tag2: 'heart_gesture',
            },

          ],
        },


      ],
    }
  },
  methods: {
    jumpChild(list, index) {
      console.log(list)
      console.log(index)
      console.log('跳转子集')
      this.$router.push({
        path: '/creation_tool',
        query: {
          // linkTo:list.id,
          arrange: list.id,
          relation: list.relation,
        }
      });

    },
  }
}
</script>
<style scoped lang="scss">
.aiTool {
  padding: 20px 20px 40px;
  overflow-y: auto;
  height: calc(100% - 40px);

  .Tool_item {
    .item_title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #fff;
      //margin-top: 20px;
      span {
        font-size: 12px;
        font-weight: 400;
      }

    }
    .margin_t{
      margin-top: 20px;
    }
    // 排除第一个的样式
    .list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 10px;
      .item {

        transition: box-shadow .2s ease;
        border-radius: 10px;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor:pointer;
        .item_box{
          border-radius: inherit;
          margin-left: auto;
          margin-right: auto;
          height: 100%;
          width: 100%;
          display: block;
          position: relative;
          overflow: hidden;
          background-color: #eee;

          .item_img{
            //transition: transform .2s ease;
            //aspect-ratio: auto 16 / 9;
            width: 100%;
            height: auto;
            //vertical-align: middle;
            //object-fit: cover;
            //-webkit-user-drag: none;
          }
          .item_h{
            font-weight: 700;
            font-size: 14px;
            margin: 10px 10px 0;
            min-height: 2em;
            display: flex;
            align-items: center;
            color: #666;
          }
          .item_p{
            color: #646464;
            margin:0 10px 15px;
            font-size: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
      }
      .item:hover {
        box-shadow:0 0 20px 0 #424242; /* 阴影效果 */
        .item_img{
          transform: scale(1.05); /* 放大图片 */
        }
      }

    }
  }
}

@media (max-width: 1299px) {
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-gap: 24px;
  }
}
@media (max-width: 875px) {
  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    grid-gap: 24px;
  }
}

</style>